import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
import { Countdown } from '../Countdown';
import { PriceCard } from '../PriceCard';
import { pricing } from '../../data/landing';
export function Offer() {
  return <section id="oferta" className="scroll-mt-4 bg-brand-soft px-5 py-16 md:py-24" data-id="element-196" data-mp="309m036thtxca">
      <div className="mx-auto max-w-3xl" data-id="element-197" data-mp="357nf9gnstcih">
        <div className="rounded-[2rem] bg-white p-7 text-center shadow-sm md:p-10" data-id="element-198" data-mp="3a5yrfy1kfz3v">
          <p className="flex items-center justify-center gap-2 text-sm font-black uppercase tracking-[0.15em] text-danger md:text-base" data-id="element-199" data-mp="3f4jpprx9c8po">
            <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-200" data-mp="3jwbcrsh7fwb2" />
            Precio de lanzamiento — cierra en:
          </p>
          <div className="mt-6" data-id="element-201" data-mp="3nw27g79uqwkv">
            <Countdown data-id="element-202" data-mp="3svy9i0yzodxs" />
          </div>
          <p className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-gold-soft px-4 py-2 text-base font-semibold text-charcoal" data-id="element-203" data-mp="3swzryqic42pj">
            <AlertTriangleIcon className="h-5 w-5 shrink-0 text-gold-strong" aria-hidden="true" data-id="element-204" data-mp="1klglajuwscjv" />
            Después sube {pricing.increase}. No vuelve más.
          </p>

          <div className="mt-8 text-left" data-id="element-205" data-mp="1fl2d91tb52lu">
            <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-206" data-mp="1bka2230vknmx">
              <span className="flex items-center gap-2 text-charcoal" data-id="element-207" data-mp="16lys7sakyd4p">
                <span className="relative flex h-2.5 w-2.5" data-id="element-208" data-mp="16ns1zgghpdgx">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-danger opacity-75 motion-reduce:animate-none" data-id="element-209" data-mp="23awojexzaj3z" />
                  <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-danger" data-id="element-210" data-mp="1zcqm2j46apov" />
                </span>
                Cupos al precio de lanzamiento
              </span>
              <span className="text-danger" data-id="element-211" data-mp="1pkb5nq8iy963">Quedan pocos</span>
            </div>
            <div className="mt-3 h-3 overflow-hidden rounded-full bg-line" role="progressbar" aria-valuenow={pricing.claimedPercent} aria-valuemin={0} aria-valuemax={100} data-id="element-212" data-mp="2n0qjg1vzpecf">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: `${pricing.claimedPercent}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              ease: [0.23, 1, 0.32, 1]
            }} className="h-full rounded-full bg-danger" data-id="element-213" data-mp="3157cydoqv2m8" />
            </div>
            <p className="mt-2 text-sm text-muted" data-id="element-214" data-mp="2wcecw3480igh">
              {pricing.claimedPercent}% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>

        <h2 className="mt-16 text-center text-3xl font-black uppercase tracking-tight text-brand md:text-5xl" data-id="element-215" data-mp="2nbzmwqgbaf6n">
          Elegí tu MegaPack
        </h2>
        <div className="mt-10" data-id="element-216" data-mp="2df4sain5syxn">
          <PriceCard subtitle="5 Tomos + 5 Bonos " idealFor="Quienes quieren curación de 7 a 15 días " ctaLabel="Quiero el MegaPack ahora" originalPrice="$108.000" currentPrice="$53.990" data-id="element-217" data-mp="2dg6e9i5pr5u5" />
        </div>
      </div>
    </section>;
}